var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlecheDroite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.474 16.252c1.239-1.26 3.265-1.278 4.525-0.039l17.038 16.75c0.612 0.602 0.957 1.424 0.957 2.282s-0.345 1.68-0.957 2.282l-17.038 16.75c-1.26 1.239-3.286 1.222-4.525-0.039s-1.222-3.286 0.038-4.525l11.462-11.268h-37.617c-1.767 0-3.2-1.433-3.2-3.2s1.433-3.2 3.2-3.2h37.617l-11.462-11.268c-1.26-1.239-1.277-3.265-0.038-4.525z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheDroite);
export default __webpack_public_path__ + "static/media/fleche-droite.6588e48d881483cbc12fe675c5663037.svg";
export { ForwardRef as ReactComponent };